/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Footer_Loop_TitleInputs */

const en_directory_footer_loop_title = /** @type {(inputs: Directory_Footer_Loop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stay in the loop`)
};

const zh_directory_footer_loop_title = /** @type {(inputs: Directory_Footer_Loop_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保持关注`)
};

/**
* | output |
* | --- |
* | "Stay in the loop" |
*
* @param {Directory_Footer_Loop_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_footer_loop_title = /** @type {((inputs?: Directory_Footer_Loop_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Footer_Loop_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_footer_loop_title(inputs)
	return zh_directory_footer_loop_title(inputs)
});
export { directory_footer_loop_title as "directory.footer.loop_title" }